export default __webpack_public_path__ + "static/media/student-progress-profile.2cb385b9.png";